<input #input autocomplete="off" [type]="inputType" [(ngModel)]="value" (ngModelChange)="onInput($event)" [placeholder]="placeholder" [disabled]="isDisabled" [readOnly]="edit" [tabindex]="tabIndex" (blur)="onTouched($event)" (focus)="onFocus()" />
<!-- [fxFlex]="fxFlex" -->
